// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sase","expireSoon":"styles_expireSoon__1HRpU"};